import {formatter, request} from "@/utils/request";


export namespace FormSs {
  export const Path = {
    getFormSs: '/expenseapi/formSs/getFormSs',
    getFormSsDetailsForApply: '/expenseapi/formSs/getFormSsDetailsForApply',
    getValidFormSs: '/expenseapi/formSs/getValidFormSs',
    getFormSsDetailsForApproval: '/expenseapi/formSs/getFormSsDetailsForApproval',
    getFormSsDetailsGroup: '/expenseapi/formSs/getFormSsDetailsGroup',
    getWarningObjsForApproval: '/expenseapi/formSs/getWarningObjsForApproval',
    ssPrintUrl: '/reportapi/print/formSsPrint',
  };

  export function getWarningObjsForApproval(formId: number) {
    const options = {
      method: 'GET',
      body: {
        formId: formId,
      },
    };
    return request<API.ResponseResult<API.WdiPanelList>>(Path.getWarningObjsForApproval, formatter(options));
  }

  export async function get(id: number) {
    const options = {
      method: 'GET',
      body: {
        id: id,
      },
    };
    return request<API.ResponseResult<API.FormSs>>(Path.getFormSs, formatter(options));
  };

  export async function getByFormSaId(id: number) {
    const options = {
      method: 'GET',
      body: {
        formSaId: id
      },
    };
    return request<API.ResponseResult<API.FormSs>>(Path.getValidFormSs, formatter(options));
  };

  export async function getFormSsDetailsForApply(body: API.FormSsParamater) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<any[]>>(Path.getFormSsDetailsForApply, formatter(options));
  };

  export async function getFormSsDetailsForApproval(id: number) {
    const options = {
      method: 'GET',
      body: {
        id: id
      },
    };
    return request<API.ResponseResult<any[]>>(Path.getFormSsDetailsForApproval, formatter(options));
  };

  export async function getFormSsDetailsGroup(body: API.FormSsParamater) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<any[]>>(Path.getFormSsDetailsGroup, formatter(options));
  };

  export namespace Buttons {
    export const Path = {
      apply: '/expenseapi/ssButtons/apply',
      del: '/expenseapi/ssButtons/delete',
      getDynamicInformation: '/expenseapi/ssButtons/dynamicInfos',
      ValidateDetail: '/expenseapi/ssButtons/validateDetail',
      ModifyAmount: '/expenseapi/ssButtons/modifyAmount',
      getSfaResultUrl: '/expenseapi/ssButtons/getSfaResultUrl',
      allowSfa: '/expenseapi/ssButtons/allowSfa',
    };

    export async function validateDetail(body: { pageTypeId: number, formSsDetail: any, }) {
      const options = {
        method: 'POST',
        body: {
          ...body
        }
      };

      return request<API.ResponseResult<API.FormSsDetailParam>>(Path.ValidateDetail, formatter(options));
    };

    export async function modifyAmount(body: { pageTypeId: number, formSsDetail: any, }) {
      const options = {
        method: 'POST',
        body: {
          ...body
        }
      };

      return request<API.ResponseResult<API.FormSsDetailParam>>(Path.ModifyAmount, formatter(options));
    };

    export async function apply(body: {
      forceSubmit: boolean,
      form: API.Form,
      formSs: API.FormSs,
      FormSSDetails: API.FormSsDetail[]
    }) {
      const options = {
        method: 'POST',
        body: body,
      };
      return request<API.ResponseResult<API.WdiPanelList>>(Path.apply, formatter(options));
    };

    export async function del(formId: number) {
      const options = {
        method: 'POST',
        body: {
          formId: formId
        },
      };
      return request<API.ResponseResult<API.WdiPanelList>>(Path.del, formatter(options));
    };

    export async function getDynamicInformation(formId: number) {
      const options = {
        method: 'Get',
        body: {
          formId: formId
        }
      };
      return request<API.DynamicInformation[]>(Path.getDynamicInformation, formatter(options));
    };

    export async function getSfaResultUrl(formId: number, formSsDetailId: number) {
      const options = {
        method: 'GET',
        body: {formId, formSsDetailId}
      };
      return request<API.ResponseResult<string>>(Path.getSfaResultUrl, formatter(options));
    };

    export async function allowSfa(body: any) {
      const options = {
        method: 'POST',
        body: {
          ...body
        }
      };
      return request<API.ResponseResult<any>>(Path.allowSfa, formatter(options));
    };
  }
}
